<template>
<vue-scroll :ops="this.$root.shared.scrollops">

    <div class="flex flex-col w-full pb-20">

        <!-- BEGIN PROCESSING MODAL COVER -->
        <div v-if="isStoring" id="modal-cover" class="absolute w-full h-full top-0 left-0" style="z-index: 9999999; background-color: rgba(7,22,29,0.8);">
            <div class="w-full h-full flex items-center justify-center">
                <span class="text-theme-main text-lg font-bold leading-normal" style="transform: translate(-35%,0);">{{ translate('content-create-processing') }}</span>
            </div>
            <div class="absolute frosted-glass w-full h-full top-0 left-0 opacity-75"></div>
        </div>
        <!-- END PROCESSING MODAL COVER -->

        <div id="sectionHeader" class="p-4 md:p-6 border-b border-theme-level2 items-center justify-between w-full">
            <h2 class="text-theme-discrete font-bold text-base md:text-xl">{{ translate("content-create-title-1") }} <span class="text-red-700" @click="getServerDateTime">{{translate("content-create-title-2") }}</span>
                <span class="text-sm text-theme-xmuted font-normal opacity-0">Server Time @ Page Load: {{ serverDateTime }}</span></h2>
        </div>

        <!-- BEGIN Data Section -->
        <div v-if="hasFinishedUpload" class="pb-4">
        <!-- USE FOR FASTER DEBUG --><!--<div v-if="true" class="pb-4">-->
            <div id="content-id-section" class="flex flex-row justify-between p-4 md:p-6 border-b border-theme-level2 w-full h-16 bg-theme-level3">
                <h2 class="text-theme-discrete font-bold text-base md:text-xl">{{ translate("content-create-editing-for") }}<span class="text-lg font-normal text-theme-main">{{ filename }}</span></h2>
                <div id="contentId" class="flex flex-row items-center relative">
                    <i class="material-icons ml-4 pl-2 pt-2 w-10 h-10 text-theme-discrete">insert_photo</i>
                    <span class="text-theme-discrete" v-text="thumbnail_state"></span>
                    <div class="thumbnailhovertrigger">
                        <img v-if="!cloudIsProcessing && thumbnail_url" class="h-10 ml-6" :src="thumbnail_url" alt="Thumbnail" />
                        <img v-else-if="cloudIsProcessing" class="h-10 ml-6" src="/images/waiting_thumbnail.png" alt="Thumbnail" />
                        <div v-if="!cloudIsProcessing && thumbnail_url" id="fullsizethumbnail" class="thumbnailhovertarget absolute transition-all duration-100" style="right: 78px; width: 520px; top: -125px">
                            <img :src="thumbnail_url" alt="Thumbnail" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- BEGIN DATA SECTION -->
            <div id="content-data-section" class="flex flex-col px-4 pt-4 pb-0 w-full text-sm">

                <div class="flex flex-row justify-between items-center mb-6">
                    <label for="fld-title" class="w-24 text-theme-muted mr-4 self-center">{{ translate("content-create-title") }}:</label>
                    <div class="border-b border-theme-level2 flex-1 w-full">
                        <input type="text" v-model="contentTitle" id="fld-title" ref="titleField" maxlength="75"
                               name="title" class="appearance-none bg-theme-level4 border-none w-full text-theme-main mr-3 py-2 px-2 focus:outline-none" />
                    </div>
                    <span class="text-sm text-theme-muted self-end ml-4">{{ contentTitle.length }}/75 caract.</span>
                </div>

                <div class="flex flex-row justify-between items-center mb-6">
                    <label for="fld-abstract" class="relative w-24 text-theme-muted mr-4 self-start label-align-top">{{ translate("content-create-abstract") }}</label>
                    <div class="border-b border-theme-level2 flex-1 w-full">
                        <textarea-autosize v-model="contentAbstract" id="fld-abstract" name="abstract" rows="1" ref="abstractField" maxlength="300"
                                           class="appearance-none bg-theme-level4 border-none w-full text-theme-main mr-3 py-1 px-2 focus:outline-none" style="line-height: 28px;"
                                           :placeholder="translate('content-create-abstract-placeholder')" :min-height="28" :max-height="140" />
                    </div>
                    <span class="text-sm text-theme-muted self-end ml-4">{{ contentAbstract.length }}/300 caract.</span>
                </div>


                <div class="flex flex-row items-center mb-6">
                    <label for="fld-categories" class="w-24 text-theme-muted self-start">{{ translate("content-create-categories") }}:</label>
                    <div class="w-4/5">
                        <ul id="fld-categories" class="flex flex-row flex-wrap">

                            <li v-if="currentlocale==='es'" v-for="(category, index) in categories" :key="category.name">
                                <!--suppress HtmlFormInputWithoutLabel -->
                                <input type="checkbox" v-model="selectedCategories"
                                       :value="category.id"
                                       class="form-checkbox h-5 w-5 text-theme-controls3 ml-4 mb-2 bg-theme-level5"
                                       :class="{ 'ml-4': index === 0}">
                                <span class="ml-2 text-theme-discrete">{{ category.name }}</span>
                            </li>

                            <li v-if="currentlocale==='en'" v-for="(category, index) in categories" :key="category.name_en">
                                <!--suppress HtmlFormInputWithoutLabel -->
                                <input type="checkbox" v-model="selectedCategories"
                                       :value="category.id"
                                       class="form-checkbox h-5 w-5 text-theme-controls3 ml-4 mb-2 bg-theme-level5"
                                       :class="{ 'ml-4': index === 0}">
                                <span class="ml-2 text-theme-discrete">{{ category.name_en }}</span>
                            </li>

                        </ul>
                    </div>
                </div>


                <div class="flex flex-row items-center mb-6">
                    <label for="fld-subcategories" class="w-24 text-theme-muted self-start">{{ translate('content-create-subcategories') }}:</label>
                    <div class="w-4/5">
                        <ul id="fld-subcategories" class="flex flex-row flex-wrap">

                            <li v-if="currentlocale==='es'" v-for="(subcategory, index) in subcategories" :key="subcategory.name">
                                <!--suppress HtmlFormInputWithoutLabel -->
                                <input type="checkbox" v-model="selectedSubCategories"
                                       :value="subcategory.id"
                                       class="form-checkbox h-5 w-5 text-theme-controls3 ml-4 mb-2 bg-theme-level5"
                                       :class="{ 'ml-4': index === 0}">
                                <span class="ml-2 text-theme-discrete">{{ subcategory.name }}</span>
                            </li>

                            <li v-if="currentlocale==='en'" v-for="(subcategory, index) in subcategories" :key="subcategory.name_en">
                                <!--suppress HtmlFormInputWithoutLabel -->
                                <input type="checkbox" v-model="selectedSubCategories"
                                       :value="subcategory.id"
                                       class="form-checkbox h-5 w-5 text-theme-controls3 ml-4 mb-2 bg-theme-level5"
                                       :class="{ 'ml-4': index === 0}">
                                <span class="ml-2 text-theme-discrete">{{ subcategory.name_en }}</span>
                            </li>

                        </ul>
                    </div>
                </div>



                <div class="flex flex-row items-center mb-6">

                    <label for="fld-tags" class="relative w-24 text-theme-muted self-start label-align-top">{{ translate("content-create-tags") }}:</label>

                    <vue-tags-input id="fld-tags"
                                    v-model="tag" :tags="selectedTags" :autocomplete-items="filteredItems"
                                    :add-only-from-autocomplete="true"
                                    @tags-changed="newTags => selectedTags = newTags"
                                    class="tags-input ml-4 border-b border-theme-level2 w-full flex-1 bg-theme-level5" />

                </div>


                <div class="flex flex-row items-center" :class="{ 'mb-4': Array.isArray(selectedPoiArray) && selectedPoiArray.length, 'mb-6': !(Array.isArray(selectedPoiArray) && selectedPoiArray.length) }">
                    <label for="fld-persons" class="w-24 text-theme-muted mr-4">{{ translate("content-create-persons") }}:</label>
                    <div class="py-1 w-1/5">
                        <v-select id="fld-persons"
                                  class="bg-theme-level5 text-theme-main"
                                  :clearable="false" :placeholder="translate('content-create-open-persons')"
                                  :options="personsList" @input="personSelected"></v-select>
                    </div>
                </div>

                <div v-if="Array.isArray(selectedPoiArray) && selectedPoiArray.length" id="radios-group" v-model="selectedPoiArray" class="mb-2">
                    <div v-model="selectedPoiArray" v-for="(person, index) in selectedPoiArray" class="flex flex-row items-center mb-4">
                        <div class="w-24 mr-4"></div>
                        <div class="w-1/5 border-b border-theme-level2 text-theme-discrete mr-4">{{ person.label }}</div>
                        <i class="material-icons ml-2 mr-4 cursor-pointer w-6 h-6 text-theme-muted hover:text-theme-main" @click="removePoiFromSelectedList(index)">delete</i>
                        <!--suppress HtmlFormInputWithoutLabel -->
                        <input v-if="person.correspondent===1" type="radio" name="selectedCorrespondent" class="form-radio h-5 w-5 text-theme-controls3" :value="person.id" v-model="correspondentId"><span v-if="person.correspondent===1" class="ml-2 text-theme-discrete">{{ translate("content-create-mark-correspondent") }}</span>
                    </div>
                </div>


                <div class="flex flex-row items-center" :class="{ 'mb-4': Array.isArray(selectedCountriesArray) && selectedCountriesArray.length, 'mb-6': !(Array.isArray(selectedCountriesArray) && selectedCountriesArray.length) }">
                    <label for="fld-persons" class="w-24 text-theme-muted mr-4">{{ translate("content-create-countries") }}:</label>
                    <div class="py-1 w-1/5">
                        <v-select id="fld-countries"
                                  class="bg-theme-level5 text-theme-main"
                                  :clearable="false" :placeholder="translate('content-create-open-countries')"
                                  :options="countriesList" @input="countrySelected"></v-select>
                    </div>
                </div>

                <div v-if="Array.isArray(selectedCountriesArray) && selectedCountriesArray.length" id="countries-radios-group" v-model="selectedCountriesArray" class="mb-2">
                  <div v-model="selectedCountriesArray" v-for="(country, index) in selectedCountriesArray" class="flex flex-row items-center mb-4">
                    <div class="w-24 mr-4"></div>
                    <div class="w-1/5 border-b border-theme-level2 text-theme-discrete mr-4">{{ country.label }}</div>
                    <i class="material-icons ml-2 mr-4 cursor-pointer w-6 h-6 text-theme-muted hover:text-theme-main" @click="removeCountryFromSelectedList(index)">delete</i>
                  </div>
                </div>

                <div class="flex flex-row items-center mb-6 w-full">

                    <label for="fld-publish" class="w-24 text-theme-muted mr-4">{{ translate("content-create-publish") }}:</label>
                    <div class="py-1 w-1/5">
                        <v-select id="fld-publish" v-model="publishActionId"
                                  :clearable="false" :placeholder="translate('content-create-publish-when')"
                                  class="bg-theme-level5 text-theme-main text-sm"
                                  :value="publishActionId"
                                  :options="[
                                      { label: translate('content-create-publish-immediately'), id: 0 },
                                      { label: translate('content-create-publish-schedule'), id: 1 }
                                      ]" @input="publishHasChanged"
                                  @change="updatePublishDate">
                        </v-select>
                    </div>

                    <div v-if="displayDateTimePicker" class="relative ml-2 flex flex-row items-center">
                        <v-date-picker
                            v-model="pickedPublishingDate"
                            :min-date='new Date()'
                            :popover="{ placement: 'bottom', visibility: 'click' }"
                            @input="updatePublishDate">
                            <button class="p-2 bg-theme-controls3 hover:bg-theme-controls2 text-theme-control-label rounded focus:outline-none">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                    class="w-4 h-4 fill-current">
                                    <path d="M1 4c0-1.1.9-2 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4zm2 2v12h14V6H3zm2-6h2v2H5V0zm8 0h2v2h-2V0zM5 9h2v2H5V9zm0 4h2v2H5v-2zm4-4h2v2H9V9zm0 4h2v2H9v-2zm4-4h2v2h-2V9zm0 4h2v2h-2v-2z" />
                                </svg>
                            </button>
                        </v-date-picker>
                        <button class="p-1 ml-1 bg-theme-controls3 hover:bg-theme-controls2 text-theme-control-label rounded focus:outline-none">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                class="w-4 h-4 fill-current"
                                style="height: 1.5rem; width: 1.5rem;"
                                @click="toggleTimePicker">
                                <g><rect fill="none" height="24" width="24"/></g>
                                <g><g><polygon points="10,8 10,14 14.7,16.9 15.5,15.7 11.5,13.3 11.5,8"/><path d="M17.92,12c0.05,0.33,0.08,0.66,0.08,1c0,3.9-3.1,7-7,7s-7-3.1-7-7c0-3.9,3.1-7,7-7c0.7,0,1.37,0.1,2,0.29V4.23 C12.36,4.08,11.69,4,11,4c-5,0-9,4-9,9s4,9,9,9s9-4,9-9c0-0.34-0.02-0.67-0.06-1H17.92z"/><polygon points="20,5 20,2 18,2 18,5 15,5 15,7 18,7 18,10 20,10 20,7 23,7 23,5"/></g></g>
                            </svg>
                        </button>
                        <div v-if="timePickerVisible" class="ml-1">
                            <vue-timepicker
                                close-on-complete
                                auto-scroll
                                hide-clear-button
                                input-width="100px"
                                :minute-interval="15"
                                @change="handleTimePicked"
                                v-model="simpleStringValue"></vue-timepicker>
                        </div>
                    </div>

                    <label for="fld-visibility" class="w-20 text-theme-muted ml-6">{{ translate("content-create-visibility") }}:</label>
                    <div class="py-1 w-1/5">
                        <v-select id="fld-visibility" v-model="contentVisibility"
                                  :clearable="false" :placeholder="translate('content-create-who-can-see')"
                                  class="bg-theme-level5 text-theme-main"
                                  :options="[
                                      { label: translate('content-create-public'), id: 1 },
                                      { label: translate('content-create-private'), id: 2 },
                                      { label: translate('content-create-unlisted'), id: 3 }
                                      ]"></v-select>
                    </div>

                    <label for="fld-restrictions" class="w-20 text-theme-muted mr-4 ml-6">{{ translate("content-create-restrictions") }}:</label>
                    <div class="py-1 w-1/5">
                        <v-select id="fld-restrictions" v-model="contentRestrictions"
                                  :clearable="false" :placeholder="translate('content-create-who-can-download')"
                                  class="bg-theme-level5 text-theme-main"
                                  :options="[
                                      { label: translate('content-create-open'), id: 1 },
                                      { label: translate('content-create-credentials'), id: 2 },
                                      { label: translate('content-create-restricted'), id: 3 }
                                      ]"></v-select>
                    </div>

                </div>
                <div v-if="scheduledPublishingDate !== ''" class="relative mt-0 flex flex-row items-center" style="top: -20px;">
                    <div class="w-24 mr-4"></div>
                    <div><span class="text-sm text-theme-muted">{{ translate("content-create-scheduled-for") }}: {{ scheduledPublishingDate }} {{ scheduledPublishingTime}}</span></div>
                </div>

                <div class="flex flex-row items-center mb-2 w-full">
                    <!--suppress XmlInvalidId -->
                    <label for="fld-module-size" class="w-24 text-theme-muted mr-4">{{ translate("content-create-module") }}:</label>
                    <!--<label for="fld-module-size" class="w-20 text-theme-muted ml-6">Visibilidad:</label>-->
                    <div class="py-1 w-1/5">
                        <input type="radio" name="selectedModuleSize" class="form-radio h-5 w-5 text-theme-controls3 bg-theme-level5" checked @click="renderSize='1'">
                        <span class="ml-2 text-theme-discrete mr-4">{{ translate("content-create-module-small") }}</span>
                        <input type="radio" name="selectedModuleSize" class="form-radio h-5 w-5 text-theme-controls3 bg-theme-level5" @click="renderSize='2'">
                        <span class="ml-2 text-theme-discrete">{{ translate("content-create-module-large") }}</span>
                    </div>
                </div>





                <div class="flex flex-row items-center mb-2 mt-4 w-full">
                    <!--suppress XmlInvalidId -->
                    <label for="fld-hero" class="w-24 text-theme-muted mr-4">{{ translate("hero-content") }}:</label>
                    <!--suppress HtmlFormInputWithoutLabel -->
                    <input type="checkbox" v-model="heroContentMarker"
                           :value="false"
                           class="form-checkbox h-5 w-5 text-theme-controls3 mb-2 bg-theme-level5"
                           @input="heroContentSelected" />
                        <span class="ml-2 text-theme-discrete">{{ translate("hero-content-label") }}</span>
                </div>

                <div v-if="heroContentSectionVisible" class="flex flex-col items-center mb-2 mt-4 w-full">

                    <div class="flex flex-row items-center mb-2 w-full">
                        <label for="thumbpick" class="w-24 text-theme-muted mr-4">{{ translate("hero-content-thumbnail") }}:</label>
                        <input type="file" accept="image/x-png,image/jpeg" class="text-theme-main" ref="heroThumbInputControl" id="thumbpick" @change="processHeroThumbnail($event.target.files)" />
                        <img v-if="heroThumbnailPreviewURL" :src="this.heroThumbnailPreviewURL" alt="" style="width: 80px;">
                        <button v-if="heroThumbnailPreviewURL && !hasFinishedUploadingThumbnail"
                                class="flex flex-row items-center justify-center text-sm bg-theme-controls3 hover:bg-theme-controls2 text-theme-control-label rounded-lg px-4 w-64 h-10 ml-4 mr-6"
                                @click="uploadThumbnail">
                            <i class="material-icons w-6 h-6 mr-2 text-theme-control-label" style="font-size: 22px;">backup</i>
                            {{ translate("content-create-upload-to-platform") }}
                        </button>
                        <progress-bar v-if="isUploadingThumbnail" size="small"
                                      :text="thumbnailUploadProgressText" :val="thumbnailUploadProgress"
                                      class="w-2/4 mt-6 text-sm text-theme-muted"></progress-bar>
                        <div v-else class="w-2/4 mt-6 text-sm text-theme-muted ml-6" v-text="thumbnailUploadProgressText"></div>
                    </div>

                    <div class="flex flex-row items-center mb-2 mt-4 w-full">
                        <!--suppress XmlInvalidId -->
                        <label for="bkgpick" class="w-24 text-theme-muted mr-4">{{ translate("hero-content-background") }}:</label>
                        <!--suppress HtmlFormInputWithoutLabel -->
                        <input type="radio" name="selectedBackground" class="form-radio h-5 w-5 text-theme-controls3" :value="0" v-model="heroContentSelectedBackground" @input="heroContentCustomBkg=false"><span class="ml-2 text-theme-discrete">{{ translate("hero-content-background") }} A</span>
                        <!--suppress HtmlFormInputWithoutLabel -->
                        <input type="radio" name="selectedBackground" class="ml-6 form-radio h-5 w-5 text-theme-controls3" :value="1" v-model="heroContentSelectedBackground" @input="heroContentCustomBkg=false"><span class="ml-2 text-theme-discrete">{{ translate("hero-content-background") }} B</span>
                        <!--suppress HtmlFormInputWithoutLabel -->
                        <input type="radio" name="selectedBackground" class="ml-6 form-radio h-5 w-5 text-theme-controls3" :value="2" v-model="heroContentSelectedBackground" @input="heroContentCustomBkg=false"><span class="ml-2 text-theme-discrete">{{ translate("hero-content-background") }} C</span>
                        <!--suppress HtmlFormInputWithoutLabel -->
                        <input type="radio" name="selectedBackground" class="ml-6 form-radio h-5 w-5 text-theme-controls3" :value="3" v-model="heroContentSelectedBackground" @input="heroContentCustomBkg=true"><span class="ml-2 text-theme-discrete">{{ translate("hero-content-custom-background") }}</span>
                    </div>

                    <div v-if="heroContentCustomBkg" class="flex flex-row items-center mb-2 mt-4 w-full">
                        <label for="bkgpick_light" class="w-24 text-theme-muted mr-4">{{ translate("hero-content-custom-background") }} Light:</label>
                        <input type="file" accept="image/x-png,image/jpeg" class="text-theme-main" ref="heroBkgInputControlLight" id="bkgpick_light" @change="processHeroCustomLightBkg($event.target.files)" />
                        <img v-if="heroCustomBkgLightPreviewURL" :src="this.heroCustomBkgLightPreviewURL" alt="" style="width: 80px;">
                        <button v-if="heroCustomBkgLightPreviewURL && !hasFinishedUploadingLightBkg"
                                class="flex flex-row items-center justify-center text-sm bg-theme-controls3 hover:bg-theme-controls2 text-theme-control-label rounded-lg px-4 w-64 h-10 ml-4 mr-6"
                                @click="uploadLightBkg">
                            <i class="material-icons w-6 h-6 mr-2 text-theme-control-label" style="font-size: 22px;">backup</i>
                            {{ translate("content-create-upload-to-platform") }}
                        </button>
                        <progress-bar v-if="isUploadingLightBkg" size="small"
                                      :text="lightBkgUploadProgressText" :val="lightBkgUploadProgress"
                                      class="w-2/4 mt-6 text-sm text-theme-muted"></progress-bar>
                        <div v-else class="w-2/4 mt-6 text-sm text-theme-muted ml-6" v-text="lightBkgUploadProgressText"></div>
                    </div>

                    <div v-if="heroContentCustomBkg" class="flex flex-row items-center mb-2 mt-4 w-full">
                        <label for="bkgpick_dark" class="w-24 text-theme-muted mr-4">{{ translate("hero-content-custom-background") }} Dark:</label>
                        <input type="file" accept="image/x-png,image/jpeg" class="text-theme-main" ref="heroBkgInputControlDark" id="bkgpick_dark" @change="processHeroCustomDarkBkg($event.target.files)" />
                        <img v-if="heroCustomBkgDarkPreviewURL" :src="this.heroCustomBkgDarkPreviewURL" alt="" style="width: 80px;">
                        <button v-if="heroCustomBkgDarkPreviewURL && !hasFinishedUploadingDarkBkg"
                                class="flex flex-row items-center justify-center text-sm bg-theme-controls3 hover:bg-theme-controls2 text-theme-control-label rounded-lg px-4 w-64 h-10 ml-4 mr-6"
                                @click="uploadDarkBkg">
                            <i class="material-icons w-6 h-6 mr-2 text-theme-control-label" style="font-size: 22px;">backup</i>
                            {{ translate("content-create-upload-to-platform") }}
                        </button>
                        <progress-bar v-if="isUploadingDarkBkg" size="small"
                                      :text="darkBkgUploadProgressText" :val="darkBkgUploadProgress"
                                      class="w-2/4 mt-6 text-sm text-theme-muted"></progress-bar>
                        <div v-else class="w-2/4 mt-6 text-sm text-theme-muted ml-6" v-text="darkBkgUploadProgressText"></div>
                    </div>

                    <div class="flex flex-row items-center mb-2 mt-4 w-full">

                        <label for="fld-hero-text" class="w-24 text-theme-muted mr-4">{{ translate("hero-content-description") }}:</label>
                        <input type="text" v-model="heroContentText" id="fld-hero-text" ref="heroTextField" maxlength="100"
                               name="herotext" class="appearance-none bg-theme-level4 border-none text-theme-main mr-3 py-2 px-2 focus:outline-none w-2/3" />
                        <span class="text-sm text-theme-muted self-end ml-4">{{ heroContentText.length }}/100</span>

                    </div>

                </div>


            </div>

            <!-- END DATA SECTION -->
            <!-- ================================================================================================================================== -->
            <!-- ================================================================================================================================== -->
            <!-- ================================================================================================================================== -->
            <!-- ================================================================================================================================== -->
            <!-- ================================================================================================================================== -->
            <hr />

                <div id="buttons-container" class="flex flex-row w-full justify-start text-sm py-6">
                    <button class="bg-theme-controls-discrete hover:bg-theme-controls2 text-theme-control-label rounded-lg px-6 h-10 ml-6" @click="cancelCreation">{{  translate("cancel") }}</button>

                    <!--<button v-if="readyToPublish" class="bg-theme-controls3 hover:bg-theme-controls2 text-theme-control-label rounded-lg px-6 h-10 ml-2" @click="storeContent">-->
                    <!--<button v-if="readyToPublish" class="bg-theme-controls3 hover:bg-theme-controls2 text-theme-control-label rounded-lg px-6 h-10 ml-2" @click="startContentStore">-->
                    <button v-if="readyToPublish" class="bg-theme-controls3 hover:bg-theme-controls2 text-theme-control-label rounded-lg px-6 h-10 ml-2" @click="storeContent">
                        <div class="flex flex-row items-center ">
                            <i class="material-icons w-6 h-6 mr-2 text-theme-control-label">publish</i>
                            <span>{{ translate("content-create") }}</span>
                        </div>
                    </button>
                    <button v-else class="bg-theme-level3 text-theme-discrete rounded-lg px-6 h-10 ml-2 cursor-default" disabled>{{ translate("content-create-missing-data") }}</button>
                </div>

            <hr />
            <!-- BEGIN UPLOAD AND PREVIZ SECTION -->

        </div>
        <!--<hr>-->
        <!-- END Data Section -->

        <!-- BEGIN Upload and PREVIZ Section -->
        <div v-if="cloudIsProcessing" id="file-upload-section" class="flex flex-col flex-none p-4 md:p-6 border-b border-theme-level2 w-full">

        <!-- USE FOR FASTER DEBUG --><!--<div v-if="false" id="file-upload-section" class="flex flex-col flex-none p-4 md:p-6 border-b border-theme-level2 w-full">-->
            <h2 class="text-theme-discrete text-lg mb-4 font-bold">{{ translate("content-create-media-to-load") }}</h2>
            <p class="text-theme-discrete mb-4 leading-normal text-sm">{{ translate("content-create-media-instructions") }}</p>
            <div class="flex flex-row justify-between items-center">
                <div class="flex flex-col">
                    <div v-if="!previewURL" class="w-64 h-32 bg-theme-level5 mr-6 flex flex-col items-center justify-center">
                        <span class="text-theme-muted text-sm">{{ translate("content-create-media-previz") }}</span>
                        <i class="material-icons w-6 h-6 mr-2 text-theme-muted">movie</i>
                    </div>
                    <div v-else class="w-64 h-32 bg-theme-level2 mr-6 flex flex-col items-center justify-center">
                        <!--<video id="previewVideoPlayer" ref="previewVideoPlayer" :src="previewURL" controls @timeupdate="updateVideoTime($event.target.currentTime)"></video>-->
                        <video id="previewVideoPlayer" ref="previewVideoPlayer"
                               :src="previewURL"
                               preload="auto"
                               controls
                               @timeupdate="updateVideoTime($event.target.currentTime)"
                               @loadedmetadata="updateDuration($event.target, $event.target.duration)">
                        </video>
                    </div>
                    <div class="flex flex-row items-center">
                        <div v-if="previewURL" class="text-theme-discrete mt-4"
                            :class="{ 'hidden':hasFinishedUpload }">
                            <p class="mb-2">{{ translate("content-create-media-thumbnail-frame") }}: {{ previewVideoFrameNumber }}</p>
                            <p>{{ translate("content-create-media-duration") }}: {{ mediaDuration }}</p>
                            <!-- TODO: Activate the Help dialog that explains this -->
                            <!--<i class="material-icons ml-4" style="font-size: 18px;">help</i>-->
                        </div>
                        <div v-else class="text-theme-discrete mt-4 self-center">{{ translate("content-create-media-thumbnail-frame") }}: ...?...
                            <!-- TODO: ...and this -->
                            <!--<i class="material-icons ml-4" style="font-size: 18px;">help</i>-->
                        </div>
                    </div>

                    <button v-if="previewVideoFrameNumber === 0" class="flex flex-row items-center justify-center text-sm bg-theme-level3 text-theme-discrete rounded-lg px-4 w-64 h-10 ml-0 mt-6" disabled>
                        <span v-if="">{{ translate("content-create-select-frame") }}...</span>
                    </button>
                    <button v-else
                            class="flex flex-row items-center justify-center text-sm bg-theme-controls3 hover:bg-theme-controls2 text-theme-control-label rounded-lg px-4 w-64 h-10 ml-0 mt-6"
                            :class="{ 'hidden': disableFileInput }"
                            @click="uploadFile">
                        <i class="material-icons w-6 h-6 mr-2 text-theme-control-label" style="font-size: 22px;">backup</i>
                        {{ translate("content-create-upload-to-platform") }}
                    </button>

                </div>
                <div class="flex flex-col w-full">


                    <label v-if="disableFileInput" for="fld-title" class="text-theme-muted mr-4">{{ translate("content-create-working-with") }}:</label>
                    <!--<label v-else for="fld-title" class="text-theme-muted mr-4 mb-4">Seleccionar el archivo a subir:</label>-->
                    <label v-if="!isEditing" for="fld-title" class="text-theme-muted mr-4 mb-4">{{ translate("content-create-select-file") }}:</label>
                    <label v-if="isEditing" for="fld-title" class="text-theme-muted mr-4 mb-4">{{ translate("content-create-current-file") }}:</label>
                    <!--<div class="border-b border-theme-level2 py-1 flex-1">-->
                    <div class="py-1 flex-1">
                        <p v-if="disableFileInput" v-text="filename" class="text-theme-main"></p>
                        <input v-else type="file" accept="video/mp4" @change="previewFile($event.target.files)" class="text-theme-main" style="background-image: none; padding: 0;" ref="fileInputControl"/>
                    </div>

                    <p v-if="isEditing" class="mb-2 mt-2 text-theme-discrete font-bold">{{ translate("content-create-content-info") }}:</p>

                    <div v-if="isEditing">
                        <span class="text-theme-discrete text-sm mb-4">{{ translate("content-create-source-name") }}: <span class="text-theme-title">{{ this.original_filename }}</span></span><br />
                        <span class="text-theme-discrete text-sm mb-4">{{ translate("content-create-dest-name") }}: <span class="text-theme-title">{{ this.filename }}</span></span><br />
                        <span class="text-theme-discrete text-sm mb-4">{{ translate("content-create-media-duration") }}: <span class="text-theme-title">{{ Math.trunc(this.localPlayer.duration) }}</span></span><br />
                        <span class="text-theme-discrete text-sm mb-4">{{ translate("content-create-media-aspect") }}: <span class="text-theme-title">16:9</span>, {{ translate("content-create-media-format") }}: <span class="text-theme-title">MP4</span></span><br />
                        <span class="text-theme-discrete text-sm mb-4">{{ translate("content-create-media-size") }}: <span class="text-theme-title">{{ this.localPlayer.videoWidth }} x {{ this.localPlayer.videoHeight }}</span></span>
                    </div>

                    <progress-bar v-if="isUploading" size="small"
                                  :text="uploadProgressText" :val="uploadProgress"
                                  class="w-3/4 mt-6 text-sm text-theme-muted"></progress-bar>
                    <div v-else class="w-3/4 mt-6 text-sm text-theme-muted" v-text="uploadProgressText"></div>
                </div>

            </div>
        </div>

        <!-- BEGIN PREVIZ SECTION -->
        <div v-else id="file-preview-section" class="flex flex-col p-4 md:p-6 border-b border-theme-level2 w-full">







            <h2 v-if="heroContentSectionVisible" class="text-theme-discrete mb-2 font-bold">{{ translate("content-edit-previz-hero") }}</h2>

            <div v-if="heroContentSectionVisible" id="hero-preview-container mb-12" class="hero-section bg-theme-level4"
                 :style="heroContentStyling">
                <div style="min-width: 498px; max-width: 498px; min-height: 280px; max-height: 280px;">
                    <img :src="heroThumbnailPreviewURL" alt="" style="max-height: 280px;">
                </div>
                <div class="px-6 py-10 flex flex-col" style="min-height: 280px; max-height: 280px; min-width: 350px; max-width: 350px;">
                    <p class="text-theme-title text-lg leading-tight font-bold mb-2" v-text="contentTitle"></p>

                    <div class="flex-1" style="max-height: 20px;"></div>

                    <div class="">
                        <p v-if="heroContentText===''" class="text-xs text-theme-main leading-normal">{{ this.contentAbstract.substring(0, 100) + '...' }}</p>
                        <p v-else class="text-xs text-theme-main leading-normal">{{ this.heroContentText }}</p>
                    </div>

                    <div class="flex-1"></div>

                    <span class="flex-1 pb-4 pt-4 text-xs text-theme-discrete flex flex-row items-center">
                        <i class="material-icons mr-2" style="font-size: 16px;">event_note</i>
                        <span class="flex-1">{{ translate("published-on") }} <span v-text="publishDatePart"></span>, {{ translate("at") }} <span v-text="publishTimePart"></span></span>
                        <i id="hero-module-options-button"
                           class="relative material-icons text-theme-muted hover:text-theme-discrete local-hover-target"
                           style="font-size: 26px;right: -10px;">more_vert</i>
                    </span>

                </div>


                <div class="moreSection invisible xl:visible flex flex-col" style="min-width: 300px;">

                    <div class="bg-theme-level2 text-sm p-8 text-theme-main mt-4 mb-2">Additional Content Area</div>
                    <div class="bg-theme-level2 text-sm p-8 text-theme-main mb-2">Additional Content Area</div>
                    <div class="bg-theme-level2 text-sm p-8 text-theme-main mb-4">Additional Content Area</div>

                </div>

            </div>









            <div id="preview-modules-container" class="flex flex-row mt-10" style="min-height: 650px;">


                <div id="small-previz" class="mr-6" style="min-width: 220px; max-width: 220px; min-height: 280px; max-height: 280px;">
                    <h2 class="text-theme-discrete mb-2 font-bold">{{ translate("content-create-previz-small") }}</h2>
                    <div class="relative desktop-item shadow rounded-lg">

                        <img :src="thumbnail_url" alt="" height="135" />

                        <p class="text-theme-main hover:text-theme-title pl-4 pr-4 pt-6 pb-4 leading-tight font-bold bg-theme-level4" v-text="contentTitle"></p>

                        <div class="flex-1 bg-theme-level4"></div>

                        <span class="px-4 pb-4 pt-2 text-xs text-theme-discrete flex flex-row items-center bg-theme-level4">
                            <i class="material-icons mr-2" style="font-size: 16px;">event_note</i>
                            <span class="flex-1"><span v-text="publishDatePart"></span>, <span v-text="publishTimePart"></span></span>
                            <!--<i id="module-options-button" class="relative material-icons cursor-pointer text-theme-muted hover:text-theme-discrete" style="font-size: 26px;right: -10px;">more_vert</i>-->
                        </span>

                        <div id="media-duration"
                             class="absolute bg-theme-dropdowndismissal w-24 h-8
                                    text-theme-control-label text-center pt-2 opacity-75
                                    border border-theme-control-label rounded-md"
                             style="top: 30%; right: 12px;" v-text="mediaDuration"></div>

                    </div>

                </div>

                <div id="large-previz" style="min-width: 440px; max-width: 440px; min-height: 570px; max-height: 570px;">

                    <h2 class="text-theme-discrete mb-2 font-bold">{{ translate("content-create-previz-large") }}</h2>
                    <div class="relative desktop-large-item shadow flex flex-col h-full">

                        <img :src="thumbnail_url" alt="" />

                        <p class="text-theme-main hover:text-theme-title px-6 pt-6 pb-4 text-xl leading-tight font-bold bg-theme-level4" v-text="contentTitle"></p>
                        <div id="abstract-text" class="w-full px-6 pt-1 pb-4 bg-theme-level4 leading-normal text-theme-discrete text-sm self-start" v-text="contentAbstract">
                        </div>

                        <div id="flex-spacer" class="flex-1 bg-theme-level4 h-full"></div>

                        <span class="flex-1 px-6 pb-4 pt-4 text-base text-theme-discrete flex flex-row items-center bg-theme-level4">
                            <i class="material-icons mr-2" style="font-size: 16px;">event_note</i>
                            <span class="flex-1">{{ translate("published-on") }} <span v-text="publishDatePart"></span>, {{ translate("at") }} <span v-text="publishTimePart"></span></span>
                            <i id="module-options-button"
                               class="relative material-icons text-theme-muted hover:text-theme-discrete local-hover-target"
                               style="font-size: 26px;right: -10px;">more_vert</i>
                        </span>

                        <!-- BEGIN Module Controls -->
                        <div class="local-hover-target-secondary transform transition-all duration-200">

                        </div>
                        <!-- END Module Controls -->
                        <div id="large-media-duration"
                             class="absolute bg-theme-dropdowndismissal w-24 h-8
                                    text-theme-control-label text-center pt-2 opacity-75
                                    border border-theme-control-label rounded-md"
                             style="top: 38%; right: 12px;" v-text="mediaDuration"></div>
                    </div>

                </div>

            </div>
        </div>
        <!-- END PREVIZ SECTION -->
        <!-- END Upload AND PREVIZ Section -->

    </div>

</vue-scroll>
</template>

<script>

    import HeroContentSection from "./HeroContentSection";
    import ProgressBar from 'vue-simple-progress';
    import VueTagsInput from '@johmun/vue-tags-input';
    import vSelect from 'vue-select';
    import VCalendar from 'v-calendar';
    /*import VueTimepicker from 'vue2-timepicker'*/
    import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'
    // import moment from 'moment';
    import moment from 'moment-timezone';

    // Styling for the Vue Select component
    import 'vue-select/dist/vue-select.css';
    import 'vue2-timepicker/dist/VueTimepicker.css';
    import translations from './messages.js';

    const Lang = require('lang.js');

    const lang = new Lang();

    lang.setMessages(translations);

    // Multipart upload constants
    const MULTIPART_THRESHOLD = 100 * 1024 * 1024; // 100 MB — files below this use simple PUT
    const CHUNK_SIZE = 50 * 1024 * 1024;            // 50 MB per part
    const MAX_CONCURRENT_UPLOADS = 3;                // parallel chunk uploads
    const MAX_RETRY_ATTEMPTS = 3;                    // retries per failed chunk

    export default {

        components: {
            HeroContentSection,
            VueTagsInput,
            ProgressBar,
            vSelect,
            VCalendar,
            VueTimepicker
        },

        computed: {

            heroContentStyling() {

                let background = '';
                let suffix = this.$root.shared.theme === 'theme-dark' ? '_dark.jpg' : '_light.jpg';

                if(this.heroContentSelectedBackground) {
                    if(this.heroContentCustomBkg) {
                        if(this.$root.shared.theme==='theme-light') {
                            background = 'url(' + this.heroCustomBkgLightPreviewURL + ')';
                        } else {
                            background = 'url(' + this.heroCustomBkgDarkPreviewURL + ')';
                        }
                    } else {
                        background = 'url(' + this.bkg_urls[this.heroContentSelectedBackground] + suffix + ')'
                    }
                } else {
                    background = 'url(' + this.bkg_urls[0] + suffix + ')'
                }

                console.log('Returning as Background URL: ' + background);

                return {
                    'min-width': '800px',
                    'min-height': '280px',
                    'max-height': '395px',
                    'max-width': '1400px',
                    'background-image': background,
                    'background-size': 'contain',
                    'background-repeat': 'no-repeat'
                }

            },

            autocompleteItems() {

                let tmp = [];

                this.tags.forEach(data => {
                    tmp.push({'text': data.name});
                })

                return tmp;

            },

            autocompleteItems_en() {

                let tmp = [];

                this.tags.forEach(data => {
                    tmp.push({'text': data.name_en});
                })

                return tmp;

            },

            bucketName() {
                return process.env.MIX_AWS_BUCKET;
            },

            mediaBucketName() {
                return process.env.MIX_AWS_MEDIA_BUCKET;
            },

            uploadProgressText() {
                if (this.isUploading) {
                    return this.uploadProgress.toString() + '%';
                }

                if (this.hasFinishedUpload) {
                    return this.translate("content-create-upload-finish");
                }
                else {
                    if (this.uploadError !== '') {
                        return 'ERROR: ' + this.uploadError;
                    } else {
                        return this.translate("content-create-inactive");
                    }
                }
            },


            thumbnailUploadProgressText() {
                if (this.isUploadingThumbnail) {
                    return this.thumbnailUploadProgress.toString() + '%';
                }

                if (this.hasFinishedUploadingThumbnail) {
                    return this.translate("content-create-upload-short");
                }
                else {
                    if (this.uploadError !== '') {
                        return 'ERROR: ' + this.uploadError;
                    } else {
                        return this.translate("content-create-inactive");
                    }
                }
            },

            lightBkgUploadProgressText() {
                if (this.isUploadingLightBkg) {
                    return this.lightBkgUploadProgress.toString() + '%';
                }

                if (this.hasFinishedUploadingLightBkg) {
                    return this.translate("content-create-upload-short");
                }
                else {
                    if (this.uploadError !== '') {
                        return 'ERROR: ' + this.uploadError;
                    } else {
                        return this.translate("content-create-inactive");
                    }
                }
            },

            darkBkgUploadProgressText() {
                if (this.isUploadingDarkBkg) {
                    return this.darkBkgUploadProgress.toString() + '%';
                }

                if (this.hasFinishedUploadingDarkBkg) {
                    return this.translate("content-create-upload-short");
                }
                else {
                    if (this.uploadError !== '') {
                        return 'ERROR: ' + this.uploadError;
                    } else {
                        return this.translate("content-create-inactive");
                    }
                }
            },

            filteredItems() {
                if(this.currentlocale==='es') {
                    return this.autocompleteItems.filter(i => {
                        return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
                    });
                } else {
                    return this.autocompleteItems_en.filter(i => {
                        return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
                    });
                }
            },

            personsList() {
                return this.persons.map(person => { return { label: person.name, id: person.id, correspondent: person.is_valid_correspondent } });
            },

            countriesList() {
                if(this.currentlocale==='es') {
                    return this.countries.map(country => {
                      return {label: country.name, id: country.id}
                    });
                } else {
                    return this.countries.map(country => {
                      return {label: country.name_en, id: country.id}
                    });
                }
            },


            readyToPublish() {

                if(this.contentTitle === '') return false;
                if(this.contentAbstract === '') return false;
                if(this.checkIfArrayEmpty(this.selectedCategories)) return false;
                /*if(this.checkIfArrayEmpty(this.selectedTags)) return false;*/
                /*if(this.checkIfArrayEmpty(this.selectedPoiArray)) return false;*/
                if(this.publishActionId === null) return false;
                if(this.scheduledPublishingDate === '') return false;
                if(this.contentVisibility === null) return false;
                if(this.contentRestrictions === null) return false;
                if(this.heroContentMarker) {
                    if(!this.hasFinishedUploadingThumbnail) return false;
                    if(this.heroContentCustomBkg) {
                        if(!this.hasFinishedUploadingLightBkg) return false;
                        if(!this.hasFinishedUploadingDarkBkg) return false;
                    }
                }

                // If we reach here, it means all data is present and we
                // can proceed on!

                return true;
            },

        },

        data() {
            return {

                /**
                 * This state variable is used to check whether the user is done
                 * creating a new piece of content or not BEFORE navigating away,
                 * in which case the browser should intercept and confirm; if the
                 * user confirms the away action, the uploaded content should
                 * be dealt wih
                 **/
                isEditing: false,
                isStoring: false,
                storingProducedErrors: false,

                thumbnail_state: this.translate("content-create-awaiting-thumbnail"),
                thumbnail_url: '',
                filename: this.translate("content-create-no-file-yet"),
                original_filename: '',
                previewURL: '',
                previewVideoTime: this.translate("content-create-time-no-start-yet"),
                previewVideoFrameNumber: 0,

                fileToUpload: null,
                isUploading: false,
                uploadProgress: 0,
                hasFinishedUpload: false,
                disableFileInput: false,
                uploadError: '',
                cloudIsProcessing: true,
                cloudPollingId: '',
                cloudSource: process.env.MIX_CLOUDFRONT_DNSNAME,

                // Multipart upload state
                multipartUploadId: null,
                multipartKey: null,
                multipartBucket: null,
                activeXHRs: [],

                // This is for the tag selector
                tag: '',

                // For the Time Picker
                timePickerVisible: false,
                simpleStringValue: '00:00',

                // BEGIN Data to commit to the database

                contentTitle: '',
                contentAbstract: '',
                correspondentId: '',
                selectedCategories: [],
                selectedSubCategories: [],
                selectedTags: [],
                selectedPoiArray: [],
                selectedCountriesArray: [],

                publishActionId: null,
                pickedPublishingDate: '',
                pickedPublishingTime: '',
                scheduledPublishingDate: moment().tz('America/Caracas').format('YYYY-MM-DD'),
                scheduledPublishingTime: moment().tz('America/Caracas').format('HH:mm'),
                publishDatePart: moment().tz('America/Caracas').format('YYYY-MM-DD HH:mm').split(' ')[0],
                publishTimePart: moment().tz('America/Caracas').format('YYYY-MM-DD HH:mm').split(' ')[1],
                uploadDate: moment().tz('America/Caracas').format('YYYY-MM-DD HH:mm'),
                mediaDuration: '00m 00s',
                contentVisibility: null,
                contentRestrictions: null,
                renderSize: '1',

                heroContentMarker: false,
                heroThumbnailToUpload: null,
                heroThumbnailFileName: '',
                heroThumbnailPreviewURL: '',
                heroContentSectionVisible: false,
                heroContentSelectedBackground: 0,
                heroContentText: '',

                heroContentCustomBkg: false,

                heroCustomBkgLightToUpload: null,
                heroCustomBkgLightFileName: '',
                heroCustomBkgDarkToUpload: null,
                heroCustomBkgDarkFileName: '',

                heroCustomBkgLightPreviewURL: '',
                heroCustomBkgDarkPreviewURL: '',

                isUploadingThumbnail: false,
                thumbnailUploadProgress: 0,
                hasFinishedUploadingThumbnail: false,

                isUploadingLightBkg: false,
                lightBkgUploadProgress: 0,
                hasFinishedUploadingLightBkg: false,

                isUploadingDarkBkg: false,
                darkBkgUploadProgress: 0,
                hasFinishedUploadingDarkBkg: false,

                contentPayload: '',
                // END Data to commit to the database

                displayDateTimePicker: false,

                localPlayer: '',
                serverDateTime: ''

            }
        },

        props: [
            'categories',
            'subcategories',
            'persons',
            'tags',
            'countries',
            'currentlocale',
            'bkg_urls'
        ],

        methods: {

            translate(key) {
                key = 'strings.' + key;
                return lang.get(key);
            },

            /**
             * Request a presigned URL from the backend for S3 upload
             */
            async getPresignedUrl(filename, contentType, bucket = 'upload', key = null, metadata = {}) {
                try {
                    const response = await axios.post('/api/s3/presigned-url', {
                        filename: filename,
                        content_type: contentType,
                        bucket: bucket,
                        key: key || filename,
                        metadata: metadata
                    });
                    return response.data;
                } catch (error) {
                    console.error('Error getting presigned URL:', error);
                    throw error;
                }
            },

            /**
             * Upload file to S3 using presigned URL with progress tracking
             */
            uploadToPresignedUrl(presignedData, file, onProgress, onComplete, onError) {
                const xhr = new XMLHttpRequest();

                // Track upload progress
                xhr.upload.addEventListener('progress', (event) => {
                    if (event.lengthComputable) {
                        const percentComplete = parseInt((event.loaded * 100) / event.total);
                        onProgress(percentComplete);
                    }
                });

                // Handle completion
                xhr.addEventListener('load', () => {
                    if (xhr.status === 200) {
                        onComplete(xhr.response);
                    } else {
                        onError(new Error(`Upload failed with status ${xhr.status}`));
                    }
                });

                // Handle errors
                xhr.addEventListener('error', () => {
                    onError(new Error('Upload failed'));
                });

                xhr.addEventListener('abort', () => {
                    onError(new Error('Upload aborted'));
                });

                // Open and send the request
                xhr.open('PUT', presignedData.url);
                xhr.setRequestHeader('Content-Type', presignedData.headers['Content-Type']);
                xhr.send(file);

                return xhr;
            },

            selectCustomBkg() {
                alert('Works!');
            },

            selectStoredBkg() {
                alert('Works Too!');
            },

            processMessage() {

                setTimeout(() => {
                    this.flashMessage.success({
                            title: this.translate("content-create-created"),
                            message: this.translate("content-create-success"),
                            blockClass: 'p-6',
                            time: 3000
                        },
                        {
                            destroyed: this.returnBack
                        });
                },  500)

            },

            returnBack() {
                window.location=document.referrer
            },

            toggleTimePicker() {

                this.timePickerVisible = !this.timePickerVisible;

            },

            showTimePicker() {

                this.timePickerVisible = true;

            },

            hideTimePicker() {

                this.timePickerVisible = false;

            },

            handleTimePicked(event) {

                this.scheduledPublishingTime = this.simpleStringValue;

            },


            storeContent() {

                console.log('Sending data to backend...');

                this.isStoring = true;

                this.contentPayload = {

                    filename: this.filename,
                    original_filename: this.original_filename,
                    title: this.contentTitle,
                    abstract: this.contentAbstract,
                    correspondent_id: this.correspondentId,
                    thumbnail_url: process.env.MIX_CLOUDFRONT_DNSNAME + this.thumbnail_url,
                    categories: this.selectedCategories,
                    subcategories: this.selectedSubCategories,
                    tags: this.selectedTags,
                    pois: this.selectedPoiArray,
                    countries: this.selectedCountriesArray,
                    publish_date: this.scheduledPublishingDate + ' ' + this.scheduledPublishingTime,
                    upload_date: this.uploadDate,
                    language: this.currentlocale,
                    render_size: parseInt(this.renderSize),
                    visibility: parseInt(this.contentVisibility.id),
                    restrictions: parseInt(this.contentRestrictions.id),
                    media_duration: this.mediaDuration,
                    legacy: false,

                    is_hero: this.heroContentMarker,
                    hero_thumbnail: this.heroThumbnailFileName,
                    hero_background: this.heroContentSelectedBackground,
                    hero_text: this.heroContentText,
                    /*hero_background_image: this.filename + '_custom_bkg_',*/
                    hero_background_image: this.heroCustomBkgDarkFileName,
                    /*hero_background_image_dark: this.filename + '_custom_bkg_'*/
                    hero_background_image_dark: this.heroCustomBkgLightFileName

                }

                axios.post('/' + this.currentlocale + '/admin/content/store', this.contentPayload)
                    .then((response) => {
                        /*console.log('Server Response: ' + response);*/
                        this.isEditing = false;
                        this.isStoring = false;

                        window.location = '/' + this.currentlocale + '/admin/content';
                    })
                    .catch((error) => {
                        console.log('There was an error storing the new content! ' + error);
                        this.storingProducedErrors = true;
                        this.isEditing = false;
                        this.isStoring = false;

                    });

            },

            previewFile(files) {

                // This being the "first" editing step taken on the page,
                // we set the isEditing state variable here

                this.isEditing = true;

                let file = files[0];

                this.fileToUpload = file;
                this.filename = file.name.split('.')[0];
                this.original_filename = this.filename;

                this.filename = 'telesur-video-' + moment().tz('America/Caracas').format('YYYY-MM-DD-HHmmssSSSSSS') ;

                this.previewURL = URL.createObjectURL(file);

                // this.videoPlayerHolder = this.$refs.videoPlayer.player;

                /*console.log('File URL: ' + this.previewURL);*/

            },

            processHeroThumbnail(files) {

                let file = files[0];

                this.heroThumbnailToUpload = file;
                this.heroThumbnailFileName = this.filename + '_hero_thumbnail';
                this.heroThumbnailPreviewURL = URL.createObjectURL(file);

            },

            processHeroCustomLightBkg(files) {

                let file = files[0];

                this.heroCustomBkgLightToUpload = file;
                this.heroCustomBkgLightFileName = this.filename + '_custom_bkg_light';
                this.heroCustomBkgLightPreviewURL = URL.createObjectURL(file);

            },

            processHeroCustomDarkBkg(files) {

                let file = files[0];

                this.heroCustomBkgDarkToUpload = file;
                this.heroCustomBkgDarkFileName = this.filename + '_custom_bkg_dark';
                this.heroCustomBkgDarkPreviewURL = URL.createObjectURL(file);

            },

            async uploadFile() {

                // First, disable the input to prevent shenanigans from users...
                this.disableFileInput = true;

                let file = this.fileToUpload;
                let newFileName = 'inputs/' + this.filename;

                this.isUploading = true;
                this.uploadProgress = 0;
                this.hasFinishedUpload = false;

                // Use multipart upload for large files, simple PUT for small ones
                if (file.size >= MULTIPART_THRESHOLD) {
                    try {
                        await this.performMultipartUpload(file, newFileName);
                    } catch (error) {
                        console.log('ERROR in multipart upload: ', error);
                        this.isUploading = false;
                        this.hasFinishedUpload = false;
                        this.uploadError = error.message || 'Multipart upload failed';
                    }
                    return;
                }

                try {
                    // Get presigned URL from backend
                    const presignedData = await this.getPresignedUrl(
                        newFileName,
                        file.type,
                        'upload',
                        newFileName,
                        {
                            'thumbnailframe': this.previewVideoFrameNumber.toString()
                        }
                    );

                    // Upload using presigned URL
                    this.uploadToPresignedUrl(
                        presignedData,
                        file,
                        // Progress callback
                        (progress) => {
                            this.uploadProgress = progress;
                        },
                        // Success callback
                        () => {
                            this.isUploading = false;
                            this.hasFinishedUpload = true;
                            this.checkIfOnS3();
                        },
                        // Error callback
                        (err) => {
                            console.log('ERROR: ', err);
                            this.isUploading = false;
                            this.hasFinishedUpload = false;
                            this.uploadError = err.message;
                        }
                    );

                } catch (error) {
                    console.log('ERROR getting presigned URL: ', error);
                    this.isUploading = false;
                    this.hasFinishedUpload = false;
                    this.uploadError = error.message;
                }
            },






            async uploadThumbnail() {

                let file = this.heroThumbnailToUpload;
                let newFileName = this.filename + '/' + process.env.MIX_BASE_THUMBNAIL_KEY + this.filename + '_hero_thumbnail.jpg';

                this.isUploadingThumbnail = true;
                this.thumbnailUploadProgress = 0;
                this.hasFinishedUploadingThumbnail = false;

                try {
                    const presignedData = await this.getPresignedUrl(
                        newFileName,
                        file.type,
                        'media',
                        newFileName
                    );

                    this.uploadToPresignedUrl(
                        presignedData,
                        file,
                        (progress) => {
                            this.thumbnailUploadProgress = progress;
                        },
                        () => {
                            this.isUploadingThumbnail = false;
                            this.hasFinishedUploadingThumbnail = true;
                        },
                        (err) => {
                            console.log('ERROR: ', err);
                            this.isUploadingThumbnail = false;
                            this.hasFinishedUploadingThumbnail = false;
                            this.uploadError = err.message;
                        }
                    );

                } catch (error) {
                    console.log('ERROR getting presigned URL: ', error);
                    this.isUploadingThumbnail = false;
                    this.hasFinishedUploadingThumbnail = false;
                    this.uploadError = error.message;
                }
            },

            async uploadLightBkg() {

                let file = this.heroCustomBkgLightToUpload;
                let newFileName = this.filename + '/' + process.env.MIX_BASE_THUMBNAIL_KEY + this.filename + '_custom_bkg_light.jpg';

                this.isUploadingLightBkg = true;
                this.lightBkgUploadProgress = 0;
                this.hasFinishedUploadingLightBkg = false;

                try {
                    const presignedData = await this.getPresignedUrl(
                        newFileName,
                        file.type,
                        'media',
                        newFileName
                    );

                    this.uploadToPresignedUrl(
                        presignedData,
                        file,
                        (progress) => {
                            this.lightBkgUploadProgress = progress;
                        },
                        () => {
                            this.isUploadingLightBkg = false;
                            this.hasFinishedUploadingLightBkg = true;
                        },
                        (err) => {
                            console.log('ERROR: ', err);
                            this.isUploadingLightBkg = false;
                            this.hasFinishedUploadingLightBkg = false;
                            this.uploadError = err.message;
                        }
                    );

                } catch (error) {
                    console.log('ERROR getting presigned URL: ', error);
                    this.isUploadingLightBkg = false;
                    this.hasFinishedUploadingLightBkg = false;
                    this.uploadError = error.message;
                }
            },

            async uploadDarkBkg() {

                let file = this.heroCustomBkgDarkToUpload;
                let newFileName = this.filename + '/' + process.env.MIX_BASE_THUMBNAIL_KEY + this.filename + '_custom_bkg_dark.jpg';

                this.isUploadingDarkBkg = true;
                this.darkBkgUploadProgress = 0;
                this.hasFinishedUploadingDarkBkg = false;

                try {
                    const presignedData = await this.getPresignedUrl(
                        newFileName,
                        file.type,
                        'media',
                        newFileName
                    );

                    this.uploadToPresignedUrl(
                        presignedData,
                        file,
                        (progress) => {
                            this.darkBkgUploadProgress = progress;
                        },
                        () => {
                            this.isUploadingDarkBkg = false;
                            this.hasFinishedUploadingDarkBkg = true;
                        },
                        (err) => {
                            console.log('ERROR: ', err);
                            this.isUploadingDarkBkg = false;
                            this.hasFinishedUploadingDarkBkg = false;
                            this.uploadError = err.message;
                        }
                    );

                } catch (error) {
                    console.log('ERROR getting presigned URL: ', error);
                    this.isUploadingDarkBkg = false;
                    this.hasFinishedUploadingDarkBkg = false;
                    this.uploadError = error.message;
                }
            },







            /**
             * Initiate a multipart upload on S3
             */
            async initiateMultipartUpload(filename, contentType, bucket, key, metadata = {}) {
                const response = await axios.post('/api/s3/multipart/initiate', {
                    filename: filename,
                    content_type: contentType,
                    bucket: bucket,
                    key: key,
                    metadata: metadata,
                });
                return response.data;
            },

            /**
             * Get presigned URLs for all parts of a multipart upload
             */
            async getMultipartPresignedUrls(uploadId, key, bucket, parts) {
                const response = await axios.post('/api/s3/multipart/presigned-urls', {
                    upload_id: uploadId,
                    key: key,
                    bucket: bucket,
                    parts: parts,
                });
                return response.data.presigned_urls;
            },

            /**
             * Abort a multipart upload, cleaning up uploaded parts on S3
             */
            async abortMultipartUpload() {
                if (!this.multipartUploadId) return;

                try {
                    await axios.post('/api/s3/multipart/abort', {
                        upload_id: this.multipartUploadId,
                        key: this.multipartKey,
                        bucket: this.multipartBucket,
                    });
                } catch (error) {
                    console.error('Error aborting multipart upload:', error);
                } finally {
                    this.multipartUploadId = null;
                    this.multipartKey = null;
                    this.multipartBucket = null;
                }
            },

            /**
             * Upload a single chunk via XHR using a presigned URL
             * Uses File.slice() for zero-copy, memory-efficient chunking
             */
            uploadChunk(url, file, start, end, partNumber) {
                return new Promise((resolve, reject) => {
                    const chunk = file.slice(start, end);
                    const xhr = new XMLHttpRequest();

                    this.activeXHRs.push(xhr);

                    xhr.open('PUT', url);

                    xhr.addEventListener('load', () => {
                        this.activeXHRs = this.activeXHRs.filter(x => x !== xhr);
                        if (xhr.status === 200) {
                            const etag = xhr.getResponseHeader('ETag');
                            resolve({ PartNumber: partNumber, ETag: etag });
                        } else {
                            reject(new Error(`Chunk ${partNumber} upload failed with status ${xhr.status}`));
                        }
                    });

                    xhr.addEventListener('error', () => {
                        this.activeXHRs = this.activeXHRs.filter(x => x !== xhr);
                        reject(new Error(`Chunk ${partNumber} upload network error`));
                    });

                    xhr.addEventListener('abort', () => {
                        this.activeXHRs = this.activeXHRs.filter(x => x !== xhr);
                        reject(new Error(`Chunk ${partNumber} upload aborted`));
                    });

                    xhr.send(chunk);
                });
            },

            /**
             * Upload a chunk with exponential backoff retry
             */
            async uploadChunkWithRetry(url, file, start, end, partNumber) {
                for (let attempt = 0; attempt < MAX_RETRY_ATTEMPTS; attempt++) {
                    try {
                        return await this.uploadChunk(url, file, start, end, partNumber);
                    } catch (error) {
                        if (attempt === MAX_RETRY_ATTEMPTS - 1) throw error;
                        const delay = Math.pow(2, attempt) * 1000; // 1s, 2s, 4s
                        console.log(`Chunk ${partNumber} failed (attempt ${attempt + 1}), retrying in ${delay}ms...`);
                        await new Promise(resolve => setTimeout(resolve, delay));
                    }
                }
            },

            /**
             * Orchestrate the full multipart upload flow
             * - Initiates the upload
             * - Gets presigned URLs for all parts
             * - Uploads chunks in parallel (up to MAX_CONCURRENT_UPLOADS)
             * - Tracks aggregate progress across all chunks
             * - Completes the upload with part ETags
             */
            async performMultipartUpload(file, key) {
                const totalParts = Math.ceil(file.size / CHUNK_SIZE);

                // Step 1: Initiate multipart upload
                const initData = await this.initiateMultipartUpload(
                    key,
                    file.type,
                    'upload',
                    key,
                    { 'thumbnailframe': this.previewVideoFrameNumber.toString() }
                );

                this.multipartUploadId = initData.upload_id;
                this.multipartKey = initData.key;
                this.multipartBucket = initData.bucket;

                // Step 2: Get presigned URLs for all parts
                const presignedUrls = await this.getMultipartPresignedUrls(
                    this.multipartUploadId,
                    this.multipartKey,
                    this.multipartBucket,
                    totalParts
                );

                // Step 3: Upload chunks with parallel workers and progress tracking
                const completedParts = [];
                let partsUploaded = 0;
                let nextPartIndex = 0;

                const uploadNextPart = async () => {
                    while (nextPartIndex < totalParts) {
                        const index = nextPartIndex++;
                        const partInfo = presignedUrls[index];
                        const start = index * CHUNK_SIZE;
                        const end = Math.min(start + CHUNK_SIZE, file.size);

                        const result = await this.uploadChunkWithRetry(
                            partInfo.url,
                            file,
                            start,
                            end,
                            partInfo.part_number
                        );

                        completedParts.push(result);
                        partsUploaded++;
                        this.uploadProgress = Math.round((partsUploaded / totalParts) * 100);
                    }
                };

                // Launch parallel workers
                const workers = [];
                for (let i = 0; i < Math.min(MAX_CONCURRENT_UPLOADS, totalParts); i++) {
                    workers.push(uploadNextPart());
                }

                await Promise.all(workers);

                // Step 4: Sort parts by part number and complete the upload
                completedParts.sort((a, b) => a.PartNumber - b.PartNumber);

                await axios.post('/api/s3/multipart/complete', {
                    upload_id: this.multipartUploadId,
                    key: this.multipartKey,
                    bucket: this.multipartBucket,
                    parts: completedParts,
                });

                // Cleanup state and signal completion
                this.multipartUploadId = null;
                this.multipartKey = null;
                this.multipartBucket = null;
                this.activeXHRs = [];
                this.isUploading = false;
                this.hasFinishedUpload = true;
                this.checkIfOnS3();
            },

            uploadImageToS3(fileToUpload, filename) {


                let file = this.fileToUpload;
                let result = false;

                /*let newFileName = filename;*/

                const uploadParams = {
                    Bucket: this.mediaBucketName,
                    Key: filename,
                    Body: file,
                    Metadata: {}
                };

                this.uploadProgress = 0;

                try {

                    this.s3.upload(uploadParams, (err, data) => {
                        if (err) {
                            console.log('ERROR: ', err);
                            this.uploadError = err;
                            result = false;
                        }
                        if (data) {
                            console.log('Upload Success! for file: ' + filename + ' - ', data);
                            result = true;
                        }
                    })
                        .on('httpUploadProgress', (progress) => {
                            this.uploadProgress = parseInt((progress.loaded * 100) / progress.total);
                            console.log('Uploading ' + filename + '... ' + this.uploadProgress + '%');
                        });

                        return true;

                } catch {

                    return false;

                }

            },




            checkIfOnS3() {

                this.cloudPollingId = setInterval( async () => {

                    let filename = (this.filename).split('.')[0];
                    /*console.log('Filename to check: ' + filename);
                    console.log('Media Bucket: ' + this.mediaBucketName);*/

                    // Construct the CloudFront URL for the thumbnail
                    const thumbnailKey = filename + '/streamables/thumbnails/' + filename + '.0000000.jpg';
                    // Ensure no double slashes in URL
                    const baseUrl = process.env.MIX_CLOUDFRONT_DNSNAME.replace(/\/$/, ''); // Remove trailing slash if present
                    const thumbnailUrl = baseUrl + '/' + thumbnailKey;

                    try {
                        // Use HEAD request to check if file exists (doesn't download the file)
                        await axios.head(thumbnailUrl);

                        // If we get here, the file exists
                        /*console.log('SUCCESS checking for thumbnail');*/
                        this.cloudIsProcessing = false;
                        this.clearCloudPolling();
                        this.updatePrevizData();
                    } catch (err) {
                        // File doesn't exist yet or error occurred
                        console.log('ERROR checking for thumbnail: ' + err);
                        this.cloudIsProcessing = true;
                    }
                }, 10000);

            },

            clearCloudPolling() {
                console.log('Clearing the Cloud Polling ID');
                clearInterval(this.cloudPollingId);
                console.log('Cleared.');
            },

            updatePrevizData() {

                this.thumbnail_url = process.env.MIX_CLOUDFRONT_DNSNAME + this.filename + '/' + process.env.MIX_BASE_THUMBNAIL_KEY + this.filename + '.0000001.jpg';
                this.thumbnail_state = "Auto-generado";
                console.log('UPDATED Thumbnail file URL to: ' + this.thumbnail_url);

            },

            updatePublishDate() {

                console.log('Publishing Action ID:' + this.publishActionId.id);

                if(this.publishActionId.id === 0) {
                    this.scheduledPublishingDate = moment().tz('America/Caracas').format('YYYY-MM-DD HH:mm').split(' ')[0];
                    this.scheduledPublishingTime = moment().tz('America/Caracas').format('YYYY-MM-DD HH:mm').split(' ')[1];
                } else {
                    if(this.pickedPublishingDate !== '') {
                        this.scheduledPublishingDate = moment(this.pickedPublishingDate).format('YYYY-MM-DD HH:mm').split(' ')[0];
                    } else {
                        this.scheduledPublishingDate = moment().tz('America/Caracas').format('YYYY-MM-DD HH:mm').split(' ')[0];
                    }
                    this.scheduledPublishingTime = moment().tz('America/Caracas').format('HH:mm');
                }

            },

            personSelected(value) {
                console.log('You selected something in the Persons dropdown: ' + JSON.stringify(value));
                this.selectedPoiArray.push(value);
            },

            countrySelected(value) {
                console.log('You selected something in the Countries dropdown: ' + JSON.stringify(value));
                this.selectedCountriesArray.push(value);
            },

            removePoiFromSelectedList(index) {
                this.selectedPoiArray.splice(index, 1)
                console.log('Removed from POIs List Index: '+ index);
            },

            removeCountryFromSelectedList(index) {
                this.selectedCountriesArray.splice(index, 1)
                console.log('Removed from Countries List Index: '+ index);
            },

            publishHasChanged(value) {
                this.displayDateTimePicker = value['id'] !== 0;
                this.updatePublishDate();
            },

            checkIfArrayEmpty(array) {
                return !(Array.isArray(array) && array.length);
            },

            updateDuration(playerRef, duration) {

                this.localPlayer = playerRef;

                let tmp_h = Math.trunc(duration / 3600);
                let remainder = duration - (tmp_h * 3600);
                let tmp_m = Math.trunc(remainder / 60);
                remainder = remainder - (tmp_m * 60);
                let tmp_s = Math.trunc(remainder);

                this.mediaDuration = (tmp_h > 0 ? this.padLeadingZeros(tmp_h, 2) + 'h ' : '') + (tmp_m > 0 ? this.padLeadingZeros(tmp_m, 2) + 'm ' : '00m') + (tmp_s > 0 ? this.padLeadingZeros(tmp_s, 2) + 's ' : '');

                    console.log('Resulting for Current Media Duration: ' + this.mediaDuration);

                let mediaHeight = '';
                let mediaWidth = '';

                if(this.localPlayer.videoWidth === 1920) {
                    mediaWidth = parseInt(this.localPlayer.videoWidth) / 120;
                } else {
                    mediaWidth = parseInt(this.localPlayer.videoWidth) / 80;
                }

                if(this.localPlayer.videoHeight === 1080) {
                    mediaHeight = parseInt(this.localPlayer.videoHeight) / 120;
                } else {
                    mediaHeight = parseInt(this.localPlayer.videoHeight) / 80;
                }

                let mediaAspectRatio = '';

                if(mediaWidth === 16 && mediaHeight === 9) {
                    mediaAspectRatio = '16:9';
                } else {
                    mediaAspectRatio = '0';
                }

                console.log('Video Dimensions: ' + this.localPlayer.videoWidth + ':' + this.localPlayer.videoHeight);
                console.log('Calculated Proportions: ' + mediaWidth + ':' + mediaHeight);

                if(mediaAspectRatio !== '16:9') {

                    // Invalidate everything, reset the module.
                    alert(this.translate("content-create-wrong-format"));

                    this.isEditing = false;

                    this.fileToUpload = '';
                    this.filename = '';
                    this.previewURL = '';

                    this.localPlayer.src = '';
                    this.$refs.fileInputControl.value = '';
                }

            },

            updateVideoTime(time) {
                // console.log('Time: ' + time); // Commented out - runs 30 times per second
                this.previewVideoTime = time;
                this.previewVideoFrameNumber = Math.trunc(this.previewVideoTime * 30)
            },

            preventNav(event) {
                if (!this.isEditing) return
                event.preventDefault()
                event.returnValue = ""
            },

            cancelCreation() {
                if (this.isEditing) {
                    if (!confirm(this.translate("content-create-abandon-confirm"))) {
                        return;
                    }
                }

                // Abort any active XHR uploads
                if (this.activeXHRs.length > 0) {
                    this.activeXHRs.forEach(xhr => xhr.abort());
                    this.activeXHRs = [];
                }

                // Abort multipart upload on S3 if one is in progress
                if (this.multipartUploadId) {
                    this.abortMultipartUpload();
                }

                window.location='/' + this.currentlocale + '/admin/content';
            },

            padLeadingZeros(num, size) {
                let s = num + "";
                while (s.length < size) s = "0" + s;
                return s;
            },

            getServerDateTime() {

                axios.get('/api/serverdatetime')
                    .then(response => {
                        console.log(response.data.hours + ':' + response.data.minutes + ':' + response.data.seconds);
                        this.serverDateTime = response.data.hours + ':' + response.data.minutes + ':' + response.data.seconds;
                        return response.data.hours + ':' + response.data.minutes + ':' + response.data.seconds;
                    }).catch(e => {
                    console.log('Error getting Date Time from Server! E: ' + e);
                })

            },

            heroContentSelected() {

                this.heroContentSectionVisible = !this.heroContentSectionVisible;

            }

        },

        beforeMount() {
            window.addEventListener("beforeunload", event => {
                if (!this.isEditing) return
                event.preventDefault()
                // Chrome requires returnValue to be set.
                event.returnValue = ""
            })
        },

        beforeDestroy() {
            window.removeEventListener("beforeunload", this.preventNav);
        },

        beforeRouteLeave(to, from, next) {
            if (this.isEditing) {
                if (!confirm(this.translate("content-create-abandon-confirm"))) {
                    return;
                }
            }
            next();
        },

        created() {

            this.getServerDateTime();

        },

        mounted() {

            this.simpleStringValue = moment().tz('America/Caracas').format('HH:mm');


        }
    }

</script>



<style lang="scss">

    /* VUE TAGS STYLING  */

    .vue-tags-input {
        max-width: 800px !important;
        background-color: var(--bg-level-5) !important;
        color: var(--txt-main) !important;
    }

    .vue-tags-input .ti-new-tag-input {
        background: transparent;
        color: var(--txt-main) !important;
    }

    .vue-tags-input .ti-autocomplete {
        background-color: var(--bg-level-5) !important;
    }

    .tags-input {

        width: 100%;
        max-width: none;

        .ti-input {
            border: none;
            border-bottom: 1px solid var(--bg-level-3);
            padding: 4px 12px;
        }
        .ti-tag input {
            color: var(--control-label);
        }
        .ti-tag, .ti-item.ti-selected-item {
            border-radius: 4px;
            background-color: var(--controls-3);
            color: var(--control-label);
        }
        .ti-tags li {
            padding: 5px 8px;
            margin:2px;
        }
        .ti-tag.dark-font {
            color: var(--txt-title);
        }
        .ti-item {
            padding: 2px 3px;
        }
        .ti-tag.ti-deletion-mark  {
            @apply bg-red-600;
            /* background-color: red !important; */
            color: var(--control-label);
        }
    }

    /* SELECT DROPDOWN STYLES */

    .vs__dropdown-toggle {
        font-size: 12px;
        border: 1px solid var(--bg-level-2) !important;
    }

    .vs__selected {
        color: var(--txt-main);
    }

    .vue__time-picker .dropdown ul li:not([disabled]).active {
        background: var(--controls-3) !important;
        color: var(--control-label) !important;
    }

    .vue__time-picker input {
        background-color: var(--bg-level-5) !important;
        color: var(--txt-main) !important;
    }

</style>

<style scoped>


    .desktop-hs > li,
    .desktop-item {
        scroll-snap-align: center;
        /*padding: calc(var(--gutter) / 2 * 1.5);*/
        display: flex;
        flex-direction: column;
        justify-content: start;
        /*align-items: center;*/
        background: #fff;
        border-radius: 8px;
        overflow: hidden;
        max-height: 280px;
        min-height: 280px;
    }

    .desktop-hs > li,
    .desktop-large-item {
        scroll-snap-align: center;
        /*padding: calc(var(--gutter) / 2 * 1.5);*/
        display: flex;
        flex-direction: column;
        justify-content: start;
        /*align-items: center;*/
        background: #fff;
        border-radius: 8px;
        overflow: hidden;
        max-height: 580px;
    }

    .icon-circled {
        background-color: var(--txt-copy-5);
    }

    .icon-circled:hover {
        background-color: var(--txt-copy-6);
        fill: var(--txt-main);
    }

    .inline-svg-icon {
        fill: var(--txt-discrete);
    }

    .inline-svg-icon:hover {
        fill: var(--txt-main);
    }

    .local-hover-trigger .local-hover-target-secondary {
        visibility: hidden;
        opacity: 0;
        height: 0rem;
    }

    .local-hover-trigger:hover .local-hover-target-secondary {
        visibility: visible;
        opacity: 1;
        height: 4rem;
    }

    .local-hover-trigger .local-hover-target {
        visibility: hidden;
        opacity: 0;
    }

    .local-hover-trigger:hover .local-hover-target {
        visibility: visible;
        opacity: 1;
    }

</style>
